<template>
  <div style="width:100%;float:left;">
    <CWidgetDropdown v-if="!fromOrder" color="gradient-success" :header="'' + data.length" text="Unfinished Orders">
      <template #footer>
        <CCardFooter class="card-footer px-3 py-2 mt-2">
          <CLink
            class="font-weight-bold font-xs btn-block text-success"
            color="info"
            @click="viewOrders()"
          >
            View Orders
            <CIcon name="cil-arrowRight" class="float-right" width="16"/>
          </CLink>
        </CCardFooter>
      </template>
    </CWidgetDropdown>
    <CModal
      title="Saved Orders"
      :show.sync="viewModal"
      size="lg"
      @update:show="checkModal"
    >
      <div style="width:100%;float:left;">
        <div v-if="loading" class="text-center py-4" role="status">Loading saved orders…</div>
        <div v-else-if="loadError" class="alert alert-warning" role="alert">
          Saved Orders could not be loaded. <CButton size="sm" color="warning" @click="getNewOrders">Retry</CButton>
        </div>
        <div v-else-if="!data.length" class="text-center py-4">No saved orders found</div>
        <!-- <table class="table" v-if="data">
          <thead>
            <tr>
              <th>PO</th>
              <th v-if="$store.state.user.user_type !== 'rep'">Saved By</th>
              <th>Cust</th>
              <th>Created</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr style="cursor: pointer;" :style="val.type === 'favor' ? 'background-color:#39f;color:#fff;' : ''" v-for="(val, index) in data">
              <td @click="goToOrder(val)">{{val.name}}</td>
              <td @click="goToOrder(val)" v-if="$store.state.user.user_type !== 'rep'">{{val.saved_by}}</td>
              <td @click="goToOrder(val)">{{val.customer_name}}</td>
              <td @click="goToOrder(val)">{{val.local_created_at}}</td>
              <td>
                <CButton size="sm" color="danger" @click="remove(val, index)">Remove</CButton>
              </td>
            </tr>
          </tbody>
        </table> -->
        <div class="all">
          <CDataTable
              :items="data"
              :fields="fields"
              column-filter
              table-filter
              sorter
              v-if="!loading && !loadError && data.length && fields"
              @row-clicked="rowClicked"
            >
              <template #saved_date="{item}">
                <td>
                  {{item.created_at}}
                </td>
              </template>
              <template #record_type="{item}">
                <td>{{ recordTypeLabel(item) }}</td>
              </template>
              <template #remove-header style="width:50px !important;">
                &nbsp;
              </template>
              <template #continue_v2="{item}">
                <td>
                  <CButton v-if="item.type === 'save_v2'" size="sm" color="primary" @click.stop="resumeInV2(item)">Resume in V2</CButton>
                  <CButton v-if="v1ConversionEnabled && item.type === 'save'" size="sm" color="info" @click.stop="continueInV2(item)">Continue in V2 (Beta)</CButton>
                </td>
              </template>
              <template #remove="{item, index}">
                <td>
                  <CButton size="sm" color="danger" @click="remove(item, index)"><CIcon name="cil-trash" /></CButton>
                </td>
              </template>
          </CDataTable>
        </div>
      </div>
      <template #footer>
        <div style="width:100%;float:left;"> </div>
      </template>
    </CModal>
  </div>
</template>
<script>
var methods = {}

methods.checkModal = function (e) {
  console.log('modal closed')
  console.log(e)
  this.$emit('closed')
}

methods.getNewOrders = function () {
  if (this.loading) return this._loadingPromise
  this.loading = true
  this.loadError = false
  const postData = {
    customer: this.customer_selected,
    csr: this.csr
  }
  var request = axios.post(this.$apiAdress + '/api/orders/getSavedOrders?token=' + localStorage.getItem('api_token'), postData).then(res => {
    console.log('SAVVVVVED orrrdERRS respone----> ', res)
    // this.data = res.data
    var arr = []
    res.data.forEach(function (val) {
      if (val.type === 'favor') {
        val._classes = 'favor'
      }
      // val.remove
      arr.push(val)
    })
    this.data = arr.sort(function (a, b) { return String(b.updated_at || b.created_at || '').localeCompare(String(a.updated_at || a.created_at || '')) })
    if (this.fromOrder && !this.launcher) {
      this.viewModal = true
    }
    this.$emit('set', 'saved_orders_widget')
  }).catch(() => {
    this.loadError = true
  }).finally(() => {
    this.loading = false
    this._loadingPromise = null
  })
  this._loadingPromise = request
  return request
}
methods.loadV1ConversionFeature = function () {
  return axios.get(this.$apiAdress + '/api/feature_toggles/v1_v2_conversion?token=' + localStorage.getItem('api_token')).then(response => {
    this.v1ConversionEnabled = Number(response.data && response.data.enabled) === 1
  }).catch(() => { this.v1ConversionEnabled = false })
}

methods.remove = function (val, index) {
  const postData = {
    val: val
  }
  axios.post(this.$apiAdress + '/api/orders/removeSavedOrder?token=' + localStorage.getItem('api_token'), postData).then(response => {
    console.log(response)
    this.data.splice(index, 1)
  })
}

methods.rowClicked = function (val, e, col) {
  console.log('Row CLICKKed Vallyyyy', val)
  if (col !== 'remove' && col !== 'continue_v2') {
    console.log('clicked order ID------>', val.id)
    this.openSavedOrder(val)
  }
}

methods.viewOrders = function () {
  this.viewModal = true
}
methods.recordTypeLabel = function (saved) {
  return saved && saved.type === 'save_v2' ? 'V2 Draft' : 'V1 Saved Order'
}
methods.openSavedOrder = function (saved) {
  if (this.fromOrder) {
    this.$emit('open-saved-order', saved)
    return
  }
  this.$router.push(saved.type === 'save_v2' ? '/create_order2/' + saved.id + '/saved' : '/create_order/' + saved.id + '/saved')
}

methods.continueInV2 = function (saved) {
  var message = 'The V1 saved order will remain unchanged. ACE will create a separate V2 draft and recalculate pricing and availability. Some decorations may require confirmation.'
  if (!window.confirm(message)) return
  this.$router.push('/create_order2/' + saved.id + '/convert_v1')
}
methods.resumeInV2 = function (saved) {
  this.openSavedOrder(saved)
}

export default {
    // ===Component name
    name: "SavedOrdersWidget",
    // ===Props passed to component
    props: ['customer_selected', 'fromOrder', 'csr', 'launcher'],
    // ===Components used by this component
    components: {

    },
    // ====component Data properties
    data(){
        return{
          data: [],
          viewModal: false,
          fields: null,
          v1ConversionEnabled: false,
          loading: false,
          loadError: false,
          _loadingPromise: null
        }
    },
    // ===Code to be executed when Component is mounted
    mounted() {
      if (!this.launcher) this.getNewOrders()
      this.loadV1ConversionFeature()
      if (this.$store.state.user.user_type !== 'rep') {
        this.fields = [
          {key: 'name' },
          {key: 'saved_by' },
          {key: 'customer_name' },
          {key: 'record_type', label: 'Type' },
          {key: 'saved_date' },
          {key: 'continue_v2', label: '' },
          {key: 'remove', _style: 'width: 75px;'}
        ]
      } else {
        // this.fields = ['name', 'customer_name', 'saved_date', 'remove']
        this.fields = [
          {key: 'name' },
          {key: 'customer_name' },
          {key: 'record_type', label: 'Type' },
          {key: 'saved_date' },
          {key: 'continue_v2', label: '' },
          {key: 'remove', _style: 'width: 75px;'}
        ]
      }
    },
    // ===Computed properties for the component
    computed: {},
    // ===Component methods
    methods: methods
}
</script>
<!-- styles -->
<!-- adding scoped attribute will apply the css to this component only -->
<style scoped></style>
